import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { QQShare } from 'ThreeTerminal_mobile';
import { h5PageCount } from 'ThreeTerminal_utils';
import Grounds from 'ThreeTerminal_base/grounds';
import Header from './header';
import Banner from './banner';
import FocusNews from './focusNews';
import BigShot from './bigShot';
import Compet from './compet';
import Knowledge from './knowledge';
import Sole from './sole';
import styles from './index.css';
import { getElectionData, getVotesData, getFocusNewsData } from '../../services/api';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        supportNum: {},
        focusNewsData: [],
        bigShotData: [],
        competData: [],
        isShowGuideLayer: true,
    };

    componentDidMount() {
        const {
            content: { base62Id, devicetype },
        } = this.props;

        if (devicetype === 'share') {
            // 分享页统计
            h5PageCount([
                {
                    behavior: 'page',
                    type: 'topic',
                    other: {
                        id: `special_ucms_${base62Id}`,
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(document.referrer),
                    },
                },
            ]);
        } else if (devicetype === 'client') {
            Grounds.pageStat({
                id: `special_ucms_${base62Id}`,
                type: 'other',
                url: encodeURIComponent(location.href),
                ref: encodeURIComponent(document.referrer),
            });
        }
    }
    async UNSAFE_componentWillMount() {
        const pollsData = await getVotesData();

        if (pollsData && pollsData.data && pollsData.data[0]) {
            const supportNum = {
                biden: pollsData.data[0].bidenNum,
                trump: pollsData.data[0].trumpNum,
            };

            this.setState({
                supportNum,
            });
        }

        let focusNewsData = await getFocusNewsData();

        if (focusNewsData && focusNewsData.length) {
            focusNewsData = focusNewsData.map((item, index) => {
                const base62Id =
                    (item.commentUrl && item.commentUrl.replace('ucms_', '')) ||
                    (item.url &&
                        item.url
                            .split('/')
                            .pop()
                            .split('?')[0]) ||
                    '';

                if (this.isClient()) {
                    return {
                        ...item,
                        type: item.type === 'short' ? 'article' : item.type,
                        newStyle: 'titleimg',
                        base62Id,
                        url: `https://ishare.ifeng.com/c/s/${base62Id}`,
                    };
                }

                if (!this.isClient()) {
                    if (index > 1) {
                        return {
                            ...item,
                            newStyle: 'titleimg',
                            type: item.type === 'short' ? 'article' : item.type,
                            base62Id,
                            url: `https://ishare.ifeng.com/c/s/${base62Id}`,
                            callUp: 1,
                            kind: 'inter_dsjzt01',
                            noPrefixKind: 1,
                            newstype: item.type,
                            downloads: {
                                download:
                                    'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191364941',
                                downloadAd:
                                    'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8819',
                            },
                        };
                    } else {
                        return {
                            ...item,
                            newStyle: 'titleimg',
                            type: item.type === 'short' ? 'article' : item.type,
                            base62Id,
                            url: `https://ishare.ifeng.com/c/s/${base62Id}`,
                        };
                    }
                }

                return {
                    ...item,
                    type: item.type === 'short' ? 'article' : item.type,
                    base62Id,
                    url: `https://ishare.ifeng.com/c/s/${base62Id}`,
                };
            });

            this.setState({
                focusNewsData,
            });
        }
        const electionData = await getElectionData();

        if (electionData && electionData.compet && electionData.compet.length) {
            this.setState({
                competData: electionData.compet,
            });
        }

        if (electionData && electionData.bigShot && electionData.bigShot.length) {
            const map = {};
            let dest = [];

            for (let i = 0; i < electionData.bigShot.length; i++) {
                const ai = electionData.bigShot[i];

                if (!map[ai.question.replace(/[\r\n]/g, '')]) {
                    dest.push({
                        question: ai.question.replace(/[\r\n]/g, ''),
                        data: [ai],
                    });
                    map[ai.question.replace(/[\r\n]/g, '')] = ai;
                } else {
                    for (let j = 0; j < dest.length; j++) {
                        const dj = dest[j];

                        if (dj.question.replace(/[\r\n]/g, '') === ai.question.replace(/[\r\n]/g, '')) {
                            dj.data.push(ai);
                            break;
                        }
                    }
                }
            }
            dest = dest.map(item => {
                return {
                    ...item,
                    data: item.data.map(item => {
                        const base62Id =
                            (item.url &&
                                item.url
                                    .split('/')
                                    .pop()
                                    .split('?')[0]) ||
                            '';

                        return {
                            ...item,
                            type: item.type === 'short' ? 'article' : item.type,
                            base62Id,
                            url: (base62Id && `https://ishare.ifeng.com/c/s/${base62Id}`) || '',
                        };
                    }),
                };
            });

            this.setState({
                bigShotData: dest,
            });
        }
    }

    dataFilter = (data, title) => {
        let filterData = [];

        if (data && data.length > 0) {
            data.forEach(item => {
                if (
                    item.display &&
                    item.title === title &&
                    item.data &&
                    item.data.articleList &&
                    item.data.articleList.length > 0
                ) {
                    filterData = item.data.articleList;

                    filterData = filterData.map(item => {
                        const base62Id =
                            (item.commentUrl && item.commentUrl.replace('ucms_', '')) ||
                            (item.url && item.url.split('/').pop()) ||
                            '';

                        return {
                            ...item,
                            type: item.type === 'short' ? 'article' : item.type,
                            base62Id,
                            newStyle: 'titleimg',
                            url: `https://ishare.ifeng.com/c/s/${base62Id}`,
                        };
                    });
                }
            });
        }

        return filterData;
    };

    // 判断是否是客户端
    isClient = () => {
        return window && typeof window.grounds !== 'undefined';
    };

    render() {
        const {
            content: { modules, shareTitle, shareThumbnail, introduction },
            content,
        } = this.props;
        const { focusNewsData, bigShotData, competData, supportNum } = this.state;
        const soleDataData = this.dataFilter(modules, '凤凰矩阵');
        const knowledgeData = this.dataFilter(modules, '大选科普');
        const callupAppID =
            (content.customization && content.customization.extraData && content.customization.extraData.callAppID) ||
            0;
        const qqShareCofig = {
            title: shareTitle,
            img: shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: introduction || shareTitle,
            cb: () => {
                console.log('分享成功');
            },
        };
        const winner =
            (content.customization && content.customization.extraData && content.customization.extraData.winner) ||
            'none';

        return (
            <div className={styles.pageBody}>
                <QQShare content={qqShareCofig} />
                {!this.isClient() && <Header content={content} />}
                <Banner content={supportNum} winner={winner} />
                {focusNewsData.length > 0 && <FocusNews content={focusNewsData} callupAppID={callupAppID} />}
                {bigShotData.length > 0 && <BigShot content={bigShotData} />}
                {competData.length > 0 && <Compet content={competData} />}
                {soleDataData.length > 0 && <Sole content={soleDataData} />}
                {knowledgeData.length > 0 && <Knowledge content={knowledgeData} />}
            </div>
        );
    }
}

export default errorBoundary(Layout);
